import OrdersByDate from "../components/OrdersByDate";

function AllOrders() {
  // restaurantId verilmezse OrdersByDate kendi localStorage'dan alır
  return <OrdersByDate />;
}

export default AllOrders;